export const GET_INSURANCE_DATA = 'GET_INSURANCE_DATA'
export const GET_INSURANCE_DATA_SUCCESS = 'GET_INSURANCE_DATA_SUCCESS'
export const GET_INSURANCE_DATA_ERROR = 'GET_INSURANCE_DATA_ERROR'

export const RENEW_INSURANCE = 'RENEW_INSURANCE'
export const RENEW_INSURANCE_SUCCESS = 'RENEW_INSURANCE_SUCCESS'
export const RENEW_INSURANCE_ERROR = 'RENEW_INSURANCE_ERROR'

export const CLEAR_RENEW_INSURANCE_STATUS = 'CLEAR_RENEW_INSURANCE_STATUS'